import { render, staticRenderFns } from "./Almacen.vue?vue&type=template&id=65fcecb1&scoped=true"
import script from "./Almacen.vue?vue&type=script&lang=js"
export * from "./Almacen.vue?vue&type=script&lang=js"
import style0 from "./Almacen.vue?vue&type=style&index=0&id=65fcecb1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65fcecb1",
  null
  
)

export default component.exports